import { Location } from 'react-router-dom';
import { ReactElement, ReactNode } from 'react';
import { SvgIconProps } from '@mui/material';
import { isExternalUrl } from '@synergy/utils';
import { makeStyles } from '@mui/styles';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import { NavigationButton } from './navigation-button';
import { NavigationLink } from './navigation-link';

export interface NavigationLinkButtonProps {
    icon?: string | ReactElement<SvgIconProps>;
    location: Location;
    url: string;
    params?: URLSearchParams;
    text: string | ReactNode;
    inset?: boolean;
    drawerCollapsed?: boolean;
    target?: '_self' | '_blank' | '_parent' | '_top';
    isExternal?: boolean;
    onClick?: () => void;
}

const useStyles = makeStyles(() => ({
    iconFontSize: {
        fontSize: 16,
    },
}));

export const NavigationLinkButton = ({
    location,
    url,
    onClick,
    target,
    params,
    isExternal,
    ...rest
}: NavigationLinkButtonProps) => {
    const classes = useStyles();

    const isActive = location.pathname.startsWith(url);
    const isExternalLink = !!isExternal || isExternalUrl(url);

    const urlWithParams = params ? url + '?' + params.toString() : url;

    return (
        <NavigationLink url={urlWithParams} onClick={onClick} target={target} isExternal={isExternal}>
            <NavigationButton
                isActive={isActive}
                suffix={isExternalLink ? <OpenInNewIcon className={classes.iconFontSize} /> : undefined}
                {...rest}
            />
        </NavigationLink>
    );
};
